import React, { useState, useEffect } from 'react'
// //import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SearchUserSubProjectWidgets from '../../../widgets/createUserSubProject/SearchUserSubProjectWidgets'
import UserListSubProjectWidgets from '../../../widgets/createUserSubProject/UserListSubProjectWidgets'
import CreateUserSubProject from '../../../widgets/createUserSubProject/CreateUserSubProject'
import {
  getUserSettingPageSchema,
  getUserByUsername,
  searchUserSetting,
  deleteUserSetting,
} from '../../../redux/actions/subProjectUserSetting'

export default function CreateUser() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [searchError, setSearchError] = useState()
  const [deleteError, setDeleteError] = useState()
  const [searchLoading, setSearchLoading] = useState()
  const [createPanel, setCreatePanel] = useState(false)
  const [editObj, setEditObj] = useState()

  const [searchDataTable, setSearchDataTable] = useState()
  const [createUser, setCreateUser] = useState()

  // const { projectId } = useParams()

  useEffect(() => {
    // console.log('load ProjectName projectId', projectId)
    setIsLoading(true)
    handleGetSchema()
    setIsLoading(false)
  }, [])

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getUserSettingPageSchema()
      // const response = mockSchema

      setSearchDataTable(response?.forms?.searchDataTable)
      setCreateUser(response?.forms?.createUser)
      setSchema(response)
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
  }

  const handleSearch = async (request) => {
    setSearchLoading(true)
    startLoading()
    try {
      const response = await searchUserSetting(request)
      console.log('handleSearch response', response)
      setSearchDataTable(response)
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setSearchError(e.response.data.errors?.message)
      } else {
        setSearchError('เกิดข้อผิดพลาดในการค้นหา กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    doneLoading()
    setSearchLoading(false)
  }

  const handleGetToEdit = async (username) => {
    startLoading()
    try {
      let response = await getUserByUsername(username)
      response.role.options = createUser.role.options
      response.mainProject.options = createUser.mainProject.options
      setCreateUser(response)
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setSearchError(e.response.data.errors?.message)
      } else {
        setSearchError('เกิดข้อผิดพลาดในการดึงข้อมูล กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    doneLoading()
  }

  const onRemove = async (obj) => {
    // console.log('onRemove : ', obj)
    setEditObj('')
    setSearchDataTable('')
    setDeleteError('')
    startLoading()
    try {
      await deleteUserSetting(obj.userName)
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setDeleteError(e.response.data.errors?.message)
      } else {
        setDeleteError('เกิดข้อผิดพลาดในการลบ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    doneLoading()
    handleGetSchema()
  }

  const handleSearchCancel = () => {
    setEditObj('')
    setSearchDataTable('')
    handleGetSchema()
  }

  const onComplete = () => {
    setEditObj('')
    setSearchDataTable('')
    setCreatePanel(false)
    handleGetSchema()
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {!createPanel && schema.forms.searchObject && (
            <div style={{ marginBottom: 10 }}>
              <SearchUserSubProjectWidgets
                schema={schema.forms.searchObject}
                isError={searchError}
                isLoading={searchLoading}
                onSubmit={handleSearch}
                onCancel={handleSearchCancel}
              />
            </div>
          )}

          {createPanel && createUser && (
            <CreateUserSubProject
              schema={createUser}
              editObj={editObj}
              isEdit={true}
              onComplete={onComplete}
              onCancel={(data) => {
                setEditObj()
                setCreatePanel(false)
              }}
            />
          )}

          {!createPanel && searchDataTable && (
            <div style={{ marginBottom: 10 }}>
              <UserListSubProjectWidgets
                loading={searchLoading}
                schema={searchDataTable}
                deleteError={deleteError}
                onCreate={() => {
                  // console.log('onCreate')
                  setEditObj()
                  setCreatePanel(true)
                }}
                onEdit={(obj) => {
                  // console.log('onEdit')
                  setEditObj(obj)
                  handleGetToEdit(obj.userName)
                  setCreatePanel(true)
                }}
                onRemove={onRemove}
                setDeleteError={setDeleteError}
              />
            </div>
          )}
        </SidebarProposal>
      )}
    </>
  )
}
